<template>
  <div class="weiVCon videoD">
    <div class="trainListBox">
        <div v-show="isHasdata" class="noData">
          <img src="../assets/imgs/noDataIcon.png" alt="">
          <p class="noDataTit">未查询到相关数据</p>
          <p>暂无数据，请刷新重试</p>
        </div>
    </div>
   </div>
</template>
<style lang="">
  html{
    background: #fff;
  }
</style>
<script>
export default {
  name: 'videoD',
  data () {
    return {
      isHasdata:true
    }
  },
  created () {

  },
  mounted () {

    window.myVue = this
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Shouc.vue